




















import { Component, Vue } from 'vue-property-decorator'
import { FillInfoItemOfForm, OperationItemType, OptionItemType } from '../../types/type'
import { getAllFatherNodeForTree, findItemForTree, disposeFillInfoToParamsForCM } from '../../utils/toolsForCommon'
import { CommonModule, UserModule } from '../../store'
@Component({
  name: 'AddOrUpdateDisinfect',
  components: {
    'form-module': () => import('../../components/common/formModule.vue')
  }
})
export default class AddOrUpdateDisinfect extends Vue {
  public loading = false
  public headerOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]
  public bottomOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: `保存`,
      key: 'save',
      type: 'success',
      size: ''
    }
  ]
  public fillInfoList: Array<FillInfoItemOfForm> = [
    {
      title: '乡镇',
      type: 'text',
      key: 'villagesAndTownsForAddOrUpdateDisinfect',
      value: '',
      placeholder: '请输入乡镇',
      isNecessary: true,
      disabled: true,
      temporaryStorageForValue: null,
      explainText: '说明：无需输入，选择学校可自动匹配乡镇'
    },
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationNameForAddOrUpdateDisinfect',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '消杀时间',
      type: 'dateForDate',
      key: 'time',
      value: '',
      placeholder: '请选择消杀时间',
      isNecessary: true
    },
    // {
    //   title: '消杀内容',
    //   type: 'textarea',
    //   key: '',
    //   value: '',
    //   placeholder: '请输入消杀内容',
    //   isNecessary: true
    // },
    {
      title: '消杀方式',
      type: 'text',
      key: 'mode',
      value: '',
      placeholder: '请输入消杀方式',
      isNecessary: true
    },
    {
      title: '消杀时长或药品配比',
      type: 'text',
      key: 'info',
      value: '',
      placeholder: '请输入消杀时长或药品配比',
      isNecessary: true
    },
    {
      title: '消杀人员',
      type: 'text',
      key: 'operator',
      value: '',
      placeholder: '请输入消杀人员',
      isNecessary: true
    },
    {
      title: '消杀图片',
      type: 'photoForList',
      key: 'picture',
      value: '',
      placeholder: '请上传消杀图片',
      isNecessary: true,
      imgList: [],
      explainText: '说明：可上传多张图片'
    },
    {
      title: '备注',
      type: 'textarea',
      key: 'comment',
      value: '',
      placeholder: '请输入备注',
      isNecessary: false
    }
  ]

  // 新增编辑的文字展示
  get addOrUpdateTitle (): string {
    const { id } = this.$route.query
    let res: string = '新增'
    if (id && id !== 'add') {
      res = '编辑'
    }
    return `${res}`
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  async created () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.disposeForFillInfoList()
    let { id } = (this as any).$route.query
    if (!id) return (this as any).$router.go(-1)
  }

  // 选择框数据处理
  disposeForFillInfoList () {
    this.fillInfoList = this.fillInfoList.map(item => {
      switch (item.key) {
        case 'villagesAndTownsForAddOrUpdateDisinfect':
          const chooseItemForAllFather = getAllFatherNodeForTree(this.treeDataForOrganatizion, 'children', 'id', this.userInfo.organizationId)
          // 拿到乡镇的id:
          let idForTown = chooseItemForAllFather[chooseItemForAllFather.length - 2]
          if (idForTown) {
            const resForTown = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', idForTown)
            if (resForTown) {
              item.value = (resForTown as any).name
              item.temporaryStorageForValue = resForTown
            }
          }
          break
        case 'organizationNameForAddOrUpdateDisinfect':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          item.temporaryStorageForValue = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
      }
      return item
    })
  }

  async saveAll (continuousValue) {
    try {
      let whoEmpty = null
      let isEmpty = this.fillInfoList.some(item => {
        if (item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      const params = disposeFillInfoToParamsForCM(this.fillInfoList)
      let { id } = this.$route.query
      if (id && id !== 'add') {
        Object.assign(params, { id })
      }
      const { data: result } = await (this as any).$http.dailyDisinfectSave(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(`${this.addOrUpdateTitle}成功`)
      setTimeout(() => {
        if (continuousValue) {
          this.$router.replace({ name: 'AddOrUpdateDisinfect', query: { id: 'add' } })
          window.location.reload()
        } else {
          this.$router.push({ name: 'Disinfect' })
        }
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  getFormResultFromChild (result) {
    let { key, value } = result
    this.fillInfoList = this.fillInfoList.map(item => {
      if (item.key === key) {
        switch (key) {
          case 'villagesAndTownsForAddOrUpdateDisinfect':
            item.temporaryStorageForValue = value
            item.value = value.name ? value.name : '- -'
            break
          // 学校：
          case 'organizationNameForAddOrUpdateDisinfect':
            item.temporaryStorageForValue = value
            break
          case 'picture':
            item.imgList.push({
              url: value
            })
            item.value = item.imgList.map(item => item.url).join(',')
            break
          default:
            item.value = value
            break
        }
      }
      return item
    })
  }

  // 拿到多张图片：
  getFormResultForHandleRemoveForPhotoForList (result): void {
    let { key, value } = result
    this.fillInfoList = this.fillInfoList.map(item => {
      if (item.key === key) {
        switch (key) {
          case 'picture':
            item.imgList = value.map(item => {
              return {
                url: item.url
              }
            })
            item.value = item.imgList.map(item => item.url).join(',')
            break
        }
      }
      return item
    })
  }

  operationForButton ({ key }) {
    switch (key) {
      case 'back':
        this.$router.go(-1)
        break
      case 'save':
        this.saveAll((this as any).$refs.refOfFormModule.continuousValue)
        break
    }
  }
}
